// @flow
import * as React from "react";

type RenderProps = {
  isScrolledToTop: boolean
};

type ScrollProviderProps = {
  children: (renderProps: RenderProps) => React.Node
};

type ScrollProviderState = {
  isScrolledToTop: boolean
};

class ScrollProvider extends React.Component<ScrollProviderProps, ScrollProviderState> {
  state = {
    isScrolledToTop: true
  };

  componentDidMount() {
    window.addEventListener("scroll", this.handleWindowResize);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleWindowResize);
  }

  handleWindowResize = () => {
    this.calculateScrolledToTop();
  };

  calculateScrolledToTop = () => {
    const newIsScrolledToTop = window.pageYOffset <= 0;

    this.setState(state => ({
      ...(state.isScrolledToTop === newIsScrolledToTop
        ? {}
        : { isScrolledToTop: newIsScrolledToTop })
    }));
  };

  render() {
    const { children } = this.props;
    const { isScrolledToTop } = this.state;

    return children({ isScrolledToTop });
  }
}

export default ScrollProvider;
